import {Component, Input, OnInit} from '@angular/core';
import { CountryGuideService } from 'src/app/shared/services/countryGuide.service';

@Component({
  selector: 'app-country-guide',
  templateUrl: './country-guide.component.html',
  styleUrls: ['./country-guide.component.scss']
})
export class CountryGuideComponent implements OnInit {

  @Input() countryGuide: any;
  showMore: boolean;
  last: any;
  isLoading = false;
  countryId = null;
  regionId = null;
  RegionName=null;
  fileName = null;
  selectedCategoryNav = 0;
  isFirstTime = true;
  constructor(private countryGuideService: CountryGuideService) {
    
  }


  ngOnInit(): void {
    
  }
  onTabChanged($event): void {   
    if (this.countryGuide) {
      this.countryId = this.countryGuide.Country.ID;
      this.regionId = this.countryGuide.Region.ID;
      this.fileName = this.countryGuide.Country.Name;
  }           
  }
  downloadPDF (downloadTabId, displayText) {
    this.isLoading = true;
    if (!this.fileName && this.isFirstTime === true)
            {
                this.setValue();
                this.isFirstTime = false;
            }
      this.RegionName = this.countryGuide.Region.Name;
    if (!this.fileName && this.countryGuide.Country.ID) {
      this.countryGuideService.getCountryGuide({ id: this.countryGuide.Country.ID, regionid: 'null' })
      .subscribe(countryGuide => {     
            this.countryId = countryGuide.data.Data.Country.ID;
            this.regionId = countryGuide.data.Data.Region.ID;
            this.fileName = countryGuide.data.Data.Country.Name;
            this.isLoading = false;
            var downloadFileName = 'MyGuides - ' + this.fileName + (this.RegionName != null && this.RegionName != '' && downloadTabId != 4 ? ' - ' + this.RegionName : '') + ' - ' + displayText;
     
            var origin = window.location.origin;
            window.location.href = origin + '/GlobalGuideContents/GlobalGuideClientView?countryId=' + this.countryId + '&regionId=' + this.regionId + '&downloadTabId=' + downloadTabId + '&Pdf=1&filename=' + downloadFileName;

        });
    }
    if (this.fileName) {
        var downloadFileName = 'MyGuides - ' + this.fileName + (this.RegionName != null && this.RegionName != '' && downloadTabId !=4 ? ' - ' + this.RegionName : '') + ' - ' + displayText;                
               
        var origin = window.location.origin;
        window.location.href = origin + '/GlobalGuideContents/GlobalGuideClientView?countryId=' + this.countryId + '&regionId=' + this.regionId + '&downloadTabId=' + downloadTabId + '&Pdf=1&filename=' + downloadFileName;
    }
};
 setValue() {
  if (this.countryGuide) {
      this.countryId = this.countryGuide.Country.ID;
      this.regionId = this.countryGuide.Region.ID;
      this.fileName = this.countryGuide.Country.Name;
  }
}
}
